import store from '@/store'
import router from '@/routes/router'
import {USER_TYPE_CHOICES} from "./utils"

export const auth = ({next, router}) => {
    if (!store.getters.isAuthenticated) {
        return router.push({name: 'LoginPage'});
    }

    return next();
}

// Create User redirect middleware
export const userRedirect = ({next, to}) => {
    const {user_type} = store.getters.getProfile;
    let name = '';
    const toUrl = to.path;
    if (user_type === USER_TYPE_CHOICES["PTSP Admin"]) {
        if (!toUrl.startsWith('/admin')) {
            return router.push("/admin/");
        }
    } else if (user_type === USER_TYPE_CHOICES['Route Marshal']) {
        if (!toUrl.startsWith('/marshal')) {
            return router.push({name: 'MerchantListPage'});
        }
    } else if (user_type === USER_TYPE_CHOICES['Customer Care']) {
        if (!toUrl.startsWith('/cc')) {
            return router.push({name: 'CCMerchantList'});
        }
    } else {
        return router.push({name: 'LoginPage'});
    }

    return next()
};
export default {auth, userRedirect};